import { AxiosError } from 'axios';
import type { ImportUploadResponse } from './generated/models';

export type { ImportUploadResponse };

interface ProblemDetailsResponse {
    title?: string;
    detail?: string;
    errors?: Record<string, string[]>;
}

export const getImportUploadErrorMessage = (error: unknown): string => {
    const response = (error as AxiosError<ProblemDetailsResponse>).response;
    if (response?.status === 413) {
        return 'File size must not exceed 100 MB.';
    }

    const validationError = response?.data?.errors
        ? Object.values(response.data.errors).flat()[0]
        : undefined;

    return (
        validationError ??
        response?.data?.detail ??
        response?.data?.title ??
        'The file could not be uploaded. Please try again.'
    );
};
